import { Component, Input } from "@angular/core";
import { PersistentDialogChildService } from "ng/src/app/shared/persistent-dialog/persistent-dialog.service";
import { SafeHtml } from "@angular/platform-browser";

@Component({
	template: `
		<div class="p-d-flex p-flex-column" style="height: 100%">
			<ng-container *ngIf="message">
				<div class="p-d-flex p-jc-center p-ai-center" style="flex-grow: 1">
					<ng-container *ngIf="!isSafeHtml">
						<div>
							{{message}}
						</div>
					</ng-container>
					<ng-container *ngIf="isSafeHtml()">
						<div [innerHtml]="message"></div>
					</ng-container>
				</div>
				<p-divider></p-divider>
			</ng-container>
			
			<div class="p-d-flex p-jc-end p-ai-center">
				<div *ngFor="let o of options">
					<button pButton
					        [label]="o.text"
					        [class]="o.styleClass"
					        [icon]="o.icon ?? ''"
					        (click)="dismiss(o.action)">
					</button>
				</div>
			</div>
		</div>
	`,
	providers: [PersistentDialogChildService]
})
export class AlertDialogComponent {
	@Input() message?: string | SafeHtml;
	@Input() options: AlertDialogOption[] = [];
	
	constructor(
		readonly dialogChildService: PersistentDialogChildService
	) {}
	
	dismiss(first?: () => void) {
		try {
			if (typeof first === 'function') {
				first();
			}
		}
		finally {
			this.dialogChildService.close();
		}
	}
	
	isSafeHtml() {
		if (this.message == null) return false;
		return typeof this.message !== 'string';
	}
}

export interface AlertDialogOption {
	text: string
	action: () => void
	styleClass?: string
	icon?: string
}